import { SvgIcon } from '@mui/material';
import type { SvgIconProps } from '@mui/material/SvgIcon';

import type { IconType } from '../../types';

const IconName = 'Action';

const IconSvg = `
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.4168 11.3662C15.688 11.0532 15.6542 10.5795 15.3412 10.3082C15.0282 10.037 14.5545 10.0708 14.2832 10.3838L10.9108 14.2751L9.68033 13.0447C9.38744 12.7518 8.91256 12.7518 8.61967 13.0447C8.32678 13.3376 8.32678 13.8124 8.61967 14.1053L10.4197 15.9053C10.5669 16.0525 10.7687 16.1319 10.9767 16.1245C11.1848 16.1171 11.3804 16.0235 11.5168 15.8662L15.4168 11.3662Z" fill="currentColor"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.5 3.75C7.5 3.33579 7.83579 3 8.25 3H15.75C16.1642 3 16.5 3.33579 16.5 3.75V4.5H18.75C19.1642 4.5 19.5 4.83579 19.5 5.25V20.25C19.5 20.6642 19.1642 21 18.75 21H5.25C4.83579 21 4.5 20.6642 4.5 20.25V5.25C4.5 4.83579 4.83579 4.5 5.25 4.5H7.5V3.75ZM9 4.5H15V6H9V4.5ZM18 6H16.5V6.75C16.5 7.16421 16.1642 7.5 15.75 7.5H8.25C7.83579 7.5 7.5 7.16421 7.5 6.75V6H6V19.5H18V6Z" fill="currentColor"/>
  </svg>
`;

const ActionIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox='0 0 24 24' {...props}>
    <path
      d='M15.4168 11.3662C15.688 11.0532 15.6542 10.5795 15.3412 10.3082C15.0282 10.037 14.5545 10.0708 14.2832 10.3838L10.9108 14.2751L9.68033 13.0447C9.38744 12.7518 8.91256 12.7518 8.61967 13.0447C8.32678 13.3376 8.32678 13.8124 8.61967 14.1053L10.4197 15.9053C10.5669 16.0525 10.7687 16.1319 10.9767 16.1245C11.1848 16.1171 11.3804 16.0235 11.5168 15.8662L15.4168 11.3662Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.5 3.75C7.5 3.33579 7.83579 3 8.25 3H15.75C16.1642 3 16.5 3.33579 16.5 3.75V4.5H18.75C19.1642 4.5 19.5 4.83579 19.5 5.25V20.25C19.5 20.6642 19.1642 21 18.75 21H5.25C4.83579 21 4.5 20.6642 4.5 20.25V5.25C4.5 4.83579 4.83579 4.5 5.25 4.5H7.5V3.75ZM9 4.5H15V6H9V4.5ZM18 6H16.5V6.75C16.5 7.16421 16.1642 7.5 15.75 7.5H8.25C7.83579 7.5 7.5 7.16421 7.5 6.75V6H6V19.5H18V6Z'
      fill='currentColor'
    />
  </SvgIcon>
);

export default {
  name: IconName,
  title: IconName,

  IconComponent: ActionIcon,
  IconSvg: IconSvg
} as IconType;
